import { boundMethod } from 'autobind-decorator';

class SelectedProductOptions {
  _storeKey = 'selected-product-option';
  _accountId = null;
  _productId = null;
  constructor(appSession, appSessionStore, productFeedsProducts) {
    'inject';

    this._appSessionStore = appSessionStore;
    this._productFeedsProducts = productFeedsProducts;

    appSession.onSessionEnd(this._cleanUp);

    this._loadInitialState();
  }
  select(accountId, productInformation) {
    this._appSessionStore.setWithKey(this._storeKey, {
      accountId,
      id: productInformation.id,
      name: productInformation.name,
    });

    this._accountId = accountId;
    this._productId = productInformation.id;
  }
  /**
   * Removes the selected account information.
   */
  unselect() {
    this._accountId = null;
    this._productId = null;
    this._appSessionStore.deleteKey(this._storeKey);
  }
  validate(accountId, productId) {
    let result;
    const hasSavedState = this._productId !== null;
    const savedStateMatchesId = hasSavedState && productId === this._productId;

    if (hasSavedState && savedStateMatchesId) {
      result = Promise.resolve();
    } else {
      if (hasSavedState) {
        this._appSessionStore.deleteKey(this._storeKey);
      }

      result = this._loadProductInformation(accountId, productId)
      .then((productInformation) => {
        this.select(accountId, productInformation);
      });
    }

    return result
    .then(() => this._appSessionStore.getFromKey(this._storeKey));
  }
  get loading() {
    return this._loading;
  }
  get productId() {
    return this._productId;
  }
  @boundMethod
  _cleanUp() {
    this._appSessionStore.deleteKey(this._storeKey);
  }
  _loadInitialState() {
    const saved = this._appSessionStore.getFromKey(this._storeKey);
    if (saved) {
      this._productId = saved.id;
      this._accountId = saved.accountId;
    }
  }
  _loadProductInformation(accountId, productId) {
    this._loading = true;
    return this._productFeedsProducts.getProductExtract(accountId, productId)
    .then((account) => {
      this._loading = false;
      return account;
    })
    .catch((error) => {
      this._loading = false;
      return Promise.reject(error);
    });
  }
}

export { SelectedProductOptions };
